import React from 'react'
import { AppTitlePage } from '../../components/AppTitlePage'
import { useGetBiAnalyticsUrlQuery } from 'core/api/BuffetReportApi'

export const BuffetReportsBI: React.FC = () => {
  const { data, isLoading, isError } = useGetBiAnalyticsUrlQuery()

  const url = data?.urlPowerBi
  const showReport = data?.showInReport

  return (
    <div className="width-for-page-wrapper general-report-wrap">
      <AppTitlePage title="BI аналитика" />
      {isLoading && <div>Идет загрузка</div>}
      {!!showReport && (
        <iframe
          src={url}
          title="BI report"
          style={{
            width: '100%',
            height: 800,
            border: '1px solid rgba(0,0,0,0.1)',
            borderRadius: 6,
          }}
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        />
      )}

      {!isLoading && isError && !data && (
        <div>Что-то пошло не так, попробуйте еще раз</div>
      )}
    </div>
  )
}

export default BuffetReportsBI
